import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import Header from "../inc/Header";
import ReactWhatsapp from "react-whatsapp";

import belthar11_330gm from "../images/Belthar11.330gm.jpg";
import belthar11_910gm from "../images/Belthar11.910gm.jpg";
import belthar12_040gm from "../images/Belthar13.040gm.jpg";
import belthar13_600gm from "../images/Belthar13.600gm.jpg";

import belthar13_450gm from "../images/Belthat13.450gm.jpg";
import belthar13_440gm from "../images/13.440gm.jpg";
import belthar16_510gm from "../images/16.510gm.jpg";
import belthar22_310gm from "../images/22.310gm.jpg"

import belthar23_340gm from "../images/23.340gm.jpg";
import belthar23_560gm from "../images/23.560gm.jpg";
import belthar23_610gm from "../images/23.610gm.jpg";
import belthar24_110gm from "../images/24.110gm.jpg"

import belthar24_450gm from "../images/24.450gm.jpg";
import belthar25_210gm from "../images/25.210gm.jpg";
import belthar25_800gm from "../images/25.800gm.jpg";
import belthar28_080gm from "../images/28.080gm.jpg"

import belthar28_400gm from "../images/28.400gm.jpg";
import belthar28_490gm from "../images/28.490gm.jpg";
import belthar28_990gm from "../images/28.990gm.jpg";
import belthar29_200gm from "../images/29.200gm.jpg";

import belthar29_430gm from "../images/29.430gm.jpg";
import belthar30_120gm from "../images/30.120gm.jpg"
import belthar36_260gm from "../images/36.260gm.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




function BeltharPage() {
    return (
        <div>
            <Header/>
                      
                      <br/>
                        <br />
                        <br />
                        <br />
                        <ScrollToTop smooth top="100" color="maroon" />
                        <div className='colorbacklockt'>
                            <div className="album py-1">
                                <div className="container mt-3">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                            <li className="breadcrumb-item active" aria-current="page">Belthar</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={belthar11_330gm} className="card-img-top" alt="belthar11_330gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 11.330gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar11_910gm} className="card-img-top" alt="belthar11_910gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 11.910gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar12_040gm} className="card-img-top" alt="belthar12_040gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Belthar </h5>
                                                <p className="card-text">Weight: 13.040gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar13_600gm} className="card-img-top" alt="belthar13_600gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Belthar                                   </h5>
                                                <p className="card-text">Weight: 13.600gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

  <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={belthar13_450gm} className="card-img-top" alt="belthar11_330gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 13.450gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar13_440gm} className="card-img-top" alt="belthar13_440gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 13.440gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar16_510gm} className="card-img-top" alt="belthar16_510gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Belthar </h5>
                                                <p className="card-text">Weight: 16.510gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar22_310gm} className="card-img-top" alt="belthar22_310gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Belthar                                   </h5>
                                                <p className="card-text">Weight: 22.310gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={belthar23_340gm} className="card-img-top" alt="belthar23_340gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 23.340gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar23_560gm} className="card-img-top" alt="belthar23_560gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 23.560gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar23_610gm} className="card-img-top" alt="belthar23_610" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Belthar </h5>
                                                <p className="card-text">Weight: 23.610gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar24_110gm} className="card-img-top" alt="belthar24_110gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Belthar                                   </h5>
                                                <p className="card-text">Weight: 24.110gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={belthar24_450gm} className="card-img-top" alt="belthar24_450gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 24.450gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar25_210gm} className="card-img-top" alt="belthar25_210gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 25.210gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar25_800gm} className="card-img-top" alt="belthar25_800gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Belthar </h5>
                                                <p className="card-text">Weight: 25.800gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar28_080gm} className="card-img-top" alt="belthar28_080gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Belthar                                   </h5>
                                                <p className="card-text">Weight: 28.080gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={belthar28_400gm} className="card-img-top" alt="belthar28_400gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 28.400gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar28_490gm} className="card-img-top" alt="belthar28_490gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 28.490gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar28_990gm} className="card-img-top" alt="belthar28_990gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Belthar </h5>
                                                <p className="card-text">Weight: 28.990gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar29_200gm} className="card-img-top" alt="belthar29_200gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Belthar                                   </h5>
                                                <p className="card-text">Weight: 29.200gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            

             <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={belthar29_430gm} className="card-img-top" alt="belthar29_430gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 29.430gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar30_120gm} className="card-img-top" alt="belthar30_120gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Belthar</h5>
                                                <p className="card-text">Weight: 30.120gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={belthar36_260gm} className="card-img-top" alt="belthar36_260gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Belthar </h5>
                                                <p className="card-text">Weight: 36.260gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                             
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />

            <br />
        </div>
    )
}

export default BeltharPage